import React from 'react';
import { useNavigate } from 'react-router-dom';
import ButtonComponent from 'components/button/buttonComponent';
import { DASHBOARD } from 'utilities/routes';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="desktop:text-[490px] text-[250px] font-bold opacity-5 absolute desktop:top-1/2 top-1/5 left-1/2 desktop:-translate-y-1/2 -translate-x-1/2">
        404
      </div>
      <div className="absolute text-neutral-800 w-full px-4 text-center desktop:text-h1 text-h3 font-medium desktop:top-1/2 top-[20%] left-1/2 desktop:-translate-y-1/2 -translate-x-1/2">
        <p>So sorry,</p>
        <p>We couldn’t find what you were looking for</p>
        <p className="text-med-gray-3 text-base mt-2.5">
          It may be due to a broken link or a temporary issue with the service
        </p>
        <ButtonComponent
          className="mt-10 !w-fit !text-sm"
          testID="go-to-dashboard"
          onClick={() => navigate(DASHBOARD)}
        >
          Go to dashboard
        </ButtonComponent>
      </div>
    </>
  );
};

export default NotFoundPage;
